import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import Selfies from './admin/tabs/Selfies';
import Photos from './admin/tabs/Photos';
import Reports from './admin/tabs/Reports';
import Users from './admin/tabs/Users';
import Metrics from './admin/tabs/Metrics';
import LegacyApp from './LegacyApp';
import Privacy from './legal/Privacy';
import Terms from './legal/Terms';
import Contact from './legal/Contact';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/selfies" replace />} />
          <Route path="selfies" element={<Selfies />} />
          <Route path="photos" element={<Photos />} />
          <Route path="reports" element={<Reports />} />
          <Route path="users" element={<Users />} />
          <Route path="metrics" element={<Metrics />} />
        </Route>
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/*" element={<LegacyApp />} />
      </Routes>
    </BrowserRouter>
  );
}
